import { cn } from '@/utils/cn'
import { MessageCircle, BookOpen, Library /* , ShoppingBag */ } from 'lucide-react'

interface BottomNavProps {
  currentPage?: 'feed' | 'chat' | 'blog' | 'biblioteca' // | 'marketplace' | 'cursos'
}

const navItems = [
  { href: '/chat', label: 'Chat', page: 'chat' as const, icon: MessageCircle },
  { href: '/blog', label: 'Blog', page: 'blog' as const, icon: BookOpen },
  { href: '/biblioteca', label: 'Biblioteca', page: 'biblioteca' as const, icon: Library },
  // { href: '/marketplace', label: 'Market', page: 'marketplace' as const, icon: ShoppingBag },
]

export function BottomNav({ currentPage = 'chat' }: BottomNavProps) {
  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-brand-surface border-t border-brand-border z-50 transition-colors duration-300">
      <div className="flex justify-center gap-6 sm:gap-8 py-1.5 px-2">
        {navItems.map(({ href, label, page, icon: Icon }) => (
          <a
            key={page}
            href={href}
            {...(href.startsWith('http') && { target: '_blank', rel: 'noopener noreferrer' })}
            className={cn(
              "flex flex-col items-center gap-0.5 py-1.5 px-4 rounded-xl transition-all duration-200",
              currentPage === page
                ? "text-brand-primary"
                : "text-brand-text-muted hover:text-brand-text-secondary"
            )}
          >
            <div className={cn(
              "p-1.5 rounded-lg transition-all duration-200",
              currentPage === page && "bg-brand-primary-light"
            )}>
              <Icon size={26} strokeWidth={currentPage === page ? 2.5 : 1.8} />
            </div>
            <span className={cn(
              "text-[10px]",
              currentPage === page ? "font-semibold" : "font-medium"
            )}>
              {label}
            </span>
          </a>
        ))}
      </div>
    </nav>
  )
}